import { lazy, Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

// Filter state lives in URL — shareable, survives refresh (per CLAUDE.md)
const conversationSearchSchema = z.object({
  q:        z.string().optional(),
  userId:   z.string().optional(),
  model:    z.string().optional(),
  status:   z.enum(['active', 'archived', 'flagged']).optional(),
  from:     z.string().optional(),
  to:       z.string().optional(),
  page:     z.number().int().min(1).optional().default(1),
  selected: z.string().optional(),   // selected conversationId for thread viewer
});

const ConversationsScreen = lazy(() =>
  import('../screens/Conversations/ConversationsScreen').then(m => ({ default: m.ConversationsScreen })),
);

export const Route = createFileRoute('/conversations')({
  validateSearch: conversationSearchSchema,
  component: ConversationsPage,
});

function ConversationsPage() {
  return (
    <Suspense fallback={<div style={{ padding: 32, color: 'var(--lca-gray-500)', fontSize: 13 }}>Loading…</div>}>
      <ConversationsScreen />
    </Suspense>
  );
}
